import app from '../app';

export function reportTrigger(qs) {
  return app.fetchAPI({ url: '/mdapi/click?' + qs }).catch(error => {});
}

export function reportFlag(flag) {
  return app
    .fetchAPI({
      url: '/api/stat/customer',
      method: 'POST',
      data: { flag },
    })
    .catch(error => {});
}

export function reportFormId(formId) {
  return app
    .fetchAPI({
      url: '/api/report/formid',
      method: 'POST',
      data: { formId },
    })
    .catch(error => {});
}
